<template>
  <div class="home">
    <div>
      <div class="container">
        <div class="header">
          <div class="banner">
            <p class="title">{{this.text.name}}</p>
            <p class="sub-title">{{this.text.jobTitle}}</p>
            <a class="phone-cta" :href="`tel:${this.text.phoneNumber}`"><i class="fa-solid fa-phone"></i>{{this.text.phoneNumber}}</a>
          </div>
          <picture class="cover-image-picture">
            <source :srcset="`${this.publicPath}img/webp/home.webp`" type="image/webp">
            <img class="cover-image" :src="`${this.publicPath}img/home.jpg`" alt="cover">
          </picture>
        </div>
      </div>
      <div class="services mt-5">
        <section class="section">
          <div class="col-10 mx-auto">
            <p class="title">{{this.text.index.services.title}}</p>
            <divider-line />
          </div>
          <service-slider class="mt-3"></service-slider>
        </section>
        <router-link class="d-flex justify-content-center" to="/services">
          <button class="secondary">Voir tous les services <i class="fa-solid fa-paw"></i></button>
        </router-link>
      </div>

      <!-- TEAM -->
      <team-section class="section"></team-section>

      <!--Instagram feed-->
      <section class="section">
        <p class="title">{{ this.text.instagram.title }} <a :href="this.text.socials.instagram.url" target="_blank">@{{ this.text.socials.instagram.name }}</a></p>
        <divider-line :height="50" />
        <div class="row mx-auto">
          <div class="col-10 mx-auto">
            <div id="instagram-feed"><a href="https://curator.io" target="_blank" class="crt-logo crt-tag">Powered by Curator.io</a></div>
          </div>
        </div>
      </section>

      <!--Feedback-->
      <section class="section">
        <feedback-slider id="feedbackSlider"></feedback-slider>
      </section>
    </div>
  </div>
</template>

<script>
import json from '../../text.json'
import ServiceSlider from "@/components/serviceSlider.vue";
import FeedbackSlider from "@/components/feedbackSlider.vue";
import TeamSection from "@/components/teamSection.vue";
import DividerLine from "@/components/dividerLine.vue";
import { applySeo } from '@/seo';
export default {
  name: "home",

  components: {ServiceSlider, FeedbackSlider, TeamSection, DividerLine},
  data() {
    return {
      text: json,
      publicPath: '/',
      curatorUrl: process.env.VUE_APP_CURATOR_URL || ''
    }
  },

  methods: {
    loadCuratorScript() {
      if (!this.curatorUrl) {
        console.error('VUE_APP_CURATOR_URL not configured');
        return;
      }
      
      const script = document.createElement('script');
      script.src = this.curatorUrl;
      script.async = true;
      script.charset = 'UTF-8';
      document.body.appendChild(script);
    },
  },

  mounted() {
    applySeo({
      title: 'Umanité Canine | Zoothérapie & comportement canin sur la Rive-Nord',
      description: this.text.metaDescription || 'Umanité Canine est une entreprise dédiée au comportement canin et à l’intervention en zoothérapie, au service des humains et des chiens sur la Rive-Nord de Montréal.',
      path: '/'
    });
    this.loadCuratorScript();
  },
}

</script>
